import ProductService from '@/services/product.service.js'
import ProductModel from '@/models/product.model'

import {
  PRODUCTS_FETCH
} from "../actions.type";
import {
  PRODUCTS_SET_ERROR,
  PRODUCTS_SET,
  PRODUCTS_IS_LOADING
} from "../mutations.type";

const state = {
  is_loading: false,
  products: {
    bundles: [],
    deals: [],
    options: {
      recurring: {        
        base: [],
        deal: [],
        data: [],
        mins: [],
        sms: [],
        whatsApp: [],        
        fixedLte: []       
      },
      once_off: {
        base: [],
        deal: [],
        data: [],
        mins: [],
        sms: [],
        whatsApp: [],        
        fixedLte: []
      }
    }
  },
  hasError: false
};

const getters = {
  products(state) {
    return state.products;
  },
  isLoading(state) {
    return state.is_loading;
  },
};

const actions = {
  [PRODUCTS_FETCH](context) {
    context.commit(PRODUCTS_IS_LOADING, true);    
    return ProductService.getProducts()
      .then(({
        data
      }) => {
        if (data.success === "true") {
          context.commit(PRODUCTS_SET, data);
        } else {
          context.commit(PRODUCTS_SET_ERROR, true);
        }
        context.commit(PRODUCTS_IS_LOADING, false);
      })
      .catch(() => {        
        context.commit(PRODUCTS_SET_ERROR, true);
        context.commit(PRODUCTS_IS_LOADING, false);
      });
  }
};

const mutations = {
  [PRODUCTS_SET](state, data) {
    state.products.deals = transformDeals(data.deals);
    formatDealOptions(state, state.products.deals);
    state.products.bundles = transformBundles(data.bundles);
    formatBundleOptions(state, state.products.bundles);
    
  },
  [PRODUCTS_IS_LOADING](state, status) {
    state.is_loading = status;
  },
  [PRODUCTS_SET_ERROR](state, status) {
    state.hasError = status;
  }
};

function formatDealOptions(state, deals) {
  deals.forEach(function (value) {
    if (!value.is_legacy && (value.is_show || value.is_special)) {
      if (value.tag.indexOf("base_sim") < 0) {
        state.products.options.recurring.deal.push(value);
      } else {
        state.products.options.recurring.base.push(value);
      }
    }
  });
}

function formatBundleOptions(state, bundles) {
  bundles.forEach(function (value) {
    if (!value.is_legacy && (value.is_show || value.is_special)) {
      switch (value.type) {
        case "data":
          value.is_recurring ? 
            state.products.options.recurring.data.push(value) : 
            state.products.options.once_off.data.push(value);
          break;
        case "mins":
          value.is_recurring ? 
            state.products.options.recurring.mins.push(value) : 
            state.products.options.once_off.mins.push(value);
          break;
        case "sms":
          value.is_recurring ? 
            state.products.options.recurring.sms.push(value) : 
            state.products.options.once_off.sms.push(value);
          break;
        case "whatsapp":
          value.is_recurring ? 
            state.products.options.recurring.whatsApp.push(value) : 
            state.products.options.once_off.whatsApp.push(value);
          break;
        case "fixed-lte":
            value.is_recurring ? 
              state.products.options.recurring.fixedLte.push(value) : 
              state.products.options.once_off.fixedLte.push(value);
            break;
      }
    }
  });
}

function transformDeals(deals) {
  let products = [];
  deals.forEach(function (value) {    
    
    if (value.is_show || value.is_special) {
      var product = new ProductModel({
        id: value.dealid,
        name: value.deal_name,
        type: value.deal_type,
        price: parseFloat(value.price),
        description: value.deal_description,
        is_legacy: value.is_legacy,
        is_special: value.is_special,
        terms: value.terms,
        start_date: value.start_date,
        end_date: value.end_date,
        fup: value.fup,
        is_imei: value.is_imei,
        credit_limit: value.credit_limit,
        display_details: value.display_details,
        is_show: value.is_show,
        tag: value.tag,
        deal_name_id: value.deal_name_id,
        product_type: value.type
      })
      products.push(product);
    }
  });

  return products;
}

function transformBundles(bundles) {
  let products = [];
  bundles.forEach(function (value) {    
    if (value.is_show || value.is_special) {
      var product = new ProductModel({
        id: value.bundleid,
        is_bundle: true,
        name: value.amount,
        description: value.name,
        type: value.type,
        price: parseFloat(value.price),
        is_legacy: value.is_legacy,
        terms: value.terms,
        is_special: value.is_special,
        is_popular: value.ispopular,
        is_recurring: value.is_recurring,
        is_show: value.is_show,
        display_details: value.display_details
      })
      products.push(product);
    }
  });

  return products;
}

export default {
  state,
  getters,
  actions,
  mutations
}